// Componente Tab riutilizzabile.
// Props:
//   - tabs: [{ value: string, label: string, count?: number }]
//   - activeTab: string (value della tab attiva)
//   - onChange: (value: string) => void
const Tabs = ({ tabs, activeTab, onChange }) => {
    return (
        <div className="flex border-b border-neutral-200 w-full">
            {tabs.map((tab) => {
                const isActive = activeTab === tab.value;
                return (
                    <button
                        key={tab.value}
                        type="button"
                        onClick={() => onChange(tab.value)}
                        className={`
                            flex-1 px-4 py-3 text-sm font-medium transition-colors
                            border-b-2 whitespace-nowrap
                            ${isActive
                                ? 'border-[#225424] text-[#225424]'
                                : 'border-transparent text-neutral-500 hover:text-neutral-700'}
                        `}
                    >
                        {tab.label}
                        {typeof tab.count === 'number' && (
                            <span className="ml-2 text-xs opacity-70">({tab.count})</span>
                        )}
                    </button>
                );
            })}
        </div>
    );
};

export default Tabs;
